<template>
  <div class="flex flex-col-reverse xl:grid xl:grid-cols-[1fr_500px] gap-8">
    <div class="flex flex-col gap-4">
      <Field
        v-for="(field, index) in fields"
        ref="fieldComponents"
        :key="index"
        :label="field.description"
        :value="values[field.key]"
        :default="t(field.translation_key, { tenant: tenant.name }, { locale })"
        :type="
          field.max_characters && field.max_characters > 120
            ? 'textarea'
            : 'input'
        "
        :maxChars="field.max_characters"
        :tags="field.placeholders"
        @onInput="emit('onInput', { field: field.key, value: $event })"
      />
      <div class="flex gap-3 justify-end">
        <Button :disabled="cancelIsDisabled" variant="outline" @click="cancel">
          {{ t("components.buttons.cancel") }}
        </Button>
        <Button variant="primary" :disabled="submitIsDisabled" @click="update">
          {{ t("components.buttons.submit_changes") }}
        </Button>
      </div>
    </div>
    <div
      v-if="tags.length"
      class="bg-utility-gray-50 py-5 md:px-6 px-4 border rounded-xl mb-auto"
    >
      <div class="flex flex-col justify-start items-start divide-y">
        <div class="pb-4 text-secondary font-semibold">Smart Tags</div>
        <div class="flex flex-col gap-4 md:pt-4 md:divide-y-0 divide-y w-full">
          <div
            v-for="tag in tags"
            :key="tag"
            class="flex flex-col md:grid md:grid-cols-[120px_1fr] gap-1 md:gap-8 pt-4 md:pt-0"
          >
            <div class="flex justify-start items-center">
              <SmartTag :label="tag.name" />
            </div>
            <div class="text-sm text-tertiary md:pl-0 pl-0.5">
              {{ tag.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { SmartTag } from "@/Pages/Settings/MessengerFlow/Partials";
import { Field } from "@/Pages/Settings/MessengerFlow/Partials/Field";
import { Button } from "@/Shadcn/Components/ui/button";
import { computed, ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import { isEqual, clone } from "lodash";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["onInput", "update"]);

const fieldComponents = ref(null);
const { t } = useI18n();

const props = defineProps({
  tags: { type: Array, required: true },
  fields: { type: Array, required: true },
  values: { type: Array, required: true },
  locale: { type: String, required: true },
});

const tenant = usePage().props.tenant;

const originalValues = ref(clone(props.values));

const update = () => {
  emit("update");
  originalValues.value = clone(props.values);
};

const cancelIsDisabled = computed(() => {
  return isEqual(
    Object.values(props.values),
    Object.values(originalValues.value)
  );
});

const submitIsDisabled = computed(() => {
  return (
    Object.values(props.values).some((item) => item === "") ||
    isEqual(Object.values(props.values), Object.values(originalValues.value))
  );
});

const cancel = () => {
  fieldComponents.value.forEach((fieldComponent) => {
    fieldComponent.cancel();
  });
};
</script>
